import * as React from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import ReportDashboard from './ReportDashboard';

const Report: React.FC = () => {
  const { id } = useParams();

  return <ReportDashboard id={id} />;
};

export default observer(Report);
